import cx from 'classnames';

import {
  CREDIT_REJECTION_BDC_SCORING_NEGATIVE,
  CREDIT_REJECTION_EXT_SCORE_CUT,
} from 'consts/loan/responseStatusCodes';
import { STEP_PROVIDENT_PRODUCT, STEP_PSYCHOMETRIC, STEP_PRODUCT } from 'consts/loan/steps';

// eslint-disable-next-line
export const getStepAfterProvidentScoring = (
  riskGrade,
  score,
  showPsychometricTest,
  noHitProductForRiskGrades,
  message
) => {
  const isExtScoreCut = message === CREDIT_REJECTION_EXT_SCORE_CUT;
  const isScoreNegative = message === CREDIT_REJECTION_BDC_SCORING_NEGATIVE;
  const hasPositiveScore = typeof score === 'number' ? score >= 200 : showPsychometricTest;

  const isOffer = noHitProductForRiskGrades && noHitProductForRiskGrades.includes(riskGrade);
  const isProvidentProduct = !isOffer && isExtScoreCut && !hasPositiveScore;
  const isPsychometric = !isOffer && ((isExtScoreCut && hasPositiveScore) || isScoreNegative);

  const stepName = cx({
    [STEP_PRODUCT.type]: isOffer,
    [STEP_PROVIDENT_PRODUCT.type]: isProvidentProduct,
    [STEP_PSYCHOMETRIC.type]: isPsychometric,
  });

  return { stepName, isOffer, isProvidentProduct, isPsychometric };
};
